import { UI, FONT } from "../constants/tokens";
import LTR from "./LTR";

// ─── An external headline, marked as a quotation ─────────────────────────────
// One component so the home card and the intelligence detail render the same
// item identically. A headline that changes wording between the two reads as a
// different article.
//
// The whole point is that the reader can tell at a glance that these are
// somebody else's words. Three things carry that, and none of them is colour:
//   · the rule down the side — the ordinary typographic mark of a quotation
//   · a label naming what this is
//   · the source, immediately under the quote rather than adrift below the card
//
// No gold: VISION reserves it for AI insight surfaces, Pro and the one primary
// action. The insight card's own frame already carries that meaning; a gilded
// quotation inside it would be decoration, which the same rule forbids.
// figure/blockquote/figcaption is the semantic pairing, so the relationship
// survives for a screen reader too.
export default function SourceQuote({ quote, source, when, size = 22, clampLines = 0 }) {
  if (!quote?.text) return null;
  return (
    <figure style={{
      margin: 0,
      borderInlineStart: `2px solid ${UI.line.strong}`,
      paddingInlineStart: 12,
    }}>
      <figcaption style={{
        fontSize: 11, fontWeight: 700,
        color: UI.text.muted, marginBottom: 6,
      }}>
        כותרת שפורסמה
      </figcaption>

      <blockquote
        dir={quote.rtl ? "rtl" : "ltr"}
        style={{
          margin: 0,
          fontSize: size,
          fontWeight: 800,
          color: UI.text.primary,
          fontFamily: FONT.heading,
          lineHeight: 1.32,
          letterSpacing: "-.015em",
          unicodeBidi: "isolate",
          ...(clampLines ? {
            display: "-webkit-box",
            WebkitLineClamp: clampLines,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          } : null),
        }}>
        {quote.text}
      </blockquote>

      {(source || when) && (
        <div style={{
          marginTop: 6, display: "flex", gap: 6, alignItems: "center",
          flexWrap: "wrap", fontSize: 12.5,
        }}>
          {source && (
            <LTR style={{ fontWeight: 700, color: UI.text.secondary, fontFamily: FONT.latin }}>{source}</LTR>
          )}
          {source && when && <span style={{ color: UI.text.muted }}>·</span>}
          {when && <span style={{ color: UI.text.muted }}>{when}</span>}
        </div>
      )}
    </figure>
  );
}
